import React, { useEffect, useRef } from 'react';
import classes from './styles.module.scss';

export default function ContextMenu({ x, y, items, onClose, isVisible }) {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    document.addEventListener('contextmenu', onClose);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('contextmenu', onClose);
    };
  }, [isVisible, onClose]);

  // Adjust position to keep menu in viewport
  useEffect(() => {
    if (!isVisible || !menuRef.current) {
      return;
    }

    const menu = menuRef.current;
    const rect = menu.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let adjustedX = x;
    let adjustedY = y;

    // Adjust horizontal position
    if (rect.right > viewportWidth) {
      adjustedX = x - rect.width;
    }

    // Adjust vertical position
    if (rect.bottom > viewportHeight) {
      adjustedY = y - rect.height;
    }

    menu.style.left = `${adjustedX}px`;
    menu.style.top = `${adjustedY}px`;
  }, [isVisible, x, y]);

  if (!isVisible) return null;

  const handleItemClick = (item) => {
    if (item.disabled) return;
    item.onClick();
    onClose();
  };

  return (
    <div
      ref={menuRef}
      className={classes.ContextMenu}
      style={{ left: x, top: y }}
    >
      {items.map((item, index) => {
        // Generate unique key: use label for items, index with prefix for separators
        const key = item.separator ? `separator-${index}` : item.label;

        return (
          <React.Fragment key={key}>
            {item.separator ? (
              <div className={classes.separator} />
            ) : (
              <button
                type="button"
                className={classes.menuItem}
                onClick={() => handleItemClick(item)}
                disabled={item.disabled}
              >
                {item.icon && <span className={classes.icon}>{item.icon}</span>}
                <span className={classes.label}>{item.label}</span>
                {item.shortcut && (
                  <span className={classes.shortcut}>{item.shortcut}</span>
                )}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
